const careerProgression = [
  {
    label: "Current Role",
    value: "Cyber Security Analyst",
  },
  {
    label: "Next step",
    value: "Senior Security Analyst",
  },
  {
    label: "Target role",
    value: "Cyber Security Manager",
  },
];

const CareerProgressionSection = () => {
  return (
    <div className="flex flex-col border rounded-xl bg-white p-6 gap-7">
      <div className="flex flex-col gap-1">
        <span className="uppercase text-xs font-bold text-slate-600">
          Career Progression
        </span>
        <span className="font-medium text-light-black text-xs">
          Clear, matchable career path based on current experience and target
          role.
        </span>
      </div>
      <div className="flex justify-between">
        {careerProgression?.map((career) => {
          return (
            <div 
            key={career?.value}
            className="flex items-center gap-2.5 flex-1">
              <div className="h-11 w-11 rounded-full border bg-gray-50"></div>
              <div className="flex flex-col gap-1">
                <span className="text-xs font-bold text-gray-600">
                  {career?.label}
                </span>
                <span className="text-xs font-medium text-slate-800">
                  {career?.value}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex items-center flex-wrap gap-1 bg-gray-50 py-2 px-4 rounded-md border">
        <span className="text-xs font-bold w-max">You're on track.</span>
        <span className="text-xs font-medium text-light-black">
          Continue building leadership and security strategy skills to reach
          your goal.
        </span>
      </div>
    </div>
  );
};

export default CareerProgressionSection;
